import React from 'react'
import styles from './index.css'

const features = [
  'Mac OS 與 Windows 兩種作業系統均可使用',
  '提供新增主賣場範本產生器，可更快輸入與複製資料',
  '可使用 .csv 或 .xlsx 任一格式匯入',
  '目前提供一般賣場提案功能'
]

const SectionFeature = ({ content }) => {
  const contents = content || features
  return (
    <div className={styles.container}>
      <ul className={styles.listing}>
        {contents.map((element, i) => {
          return <li key={i}>{element}</li>
        })}
      </ul>
    </div>
  )
}

export default SectionFeature
